import { Container, EventBanner, SectionTitle, Timeline } from '@sloyd/ui';
import { Json } from '../../types';
import { Time, Wrapper } from './ContentEvents.style';

export type ContentEventsProps = {
  events: Json[];
};

export function ContentEvents(props: ContentEventsProps) {
  const { events } = props;

  return (
    <Wrapper className='ContentEvents-wrapper' data-testid='ContentEvents-wrapper'>
      <SectionTitle gradient={{ from: '#654ea3', to: '#eaafc8' }} title='📆 Events'>
        Stay updated with upcoming <strong>events</strong> and community activities.
      </SectionTitle>
      <Container>
        <EventBanner mp4='https://videos.pexels.com/video-files/16736783/16736783-hd_1920_1080_24fps.mp4' />
        <Time>
          <Timeline items={events} />
        </Time>
      </Container>
    </Wrapper>
  );
}

export default ContentEvents;
